import { TokenWithBalance, TokenWithValue } from '@/domain/common/types'
import { InjectedActionsContext, Objective } from '@/features/actions/logic/types'
import { DialogActionsPanel } from '@/features/dialogs/common/components/DialogActionsPanel'
import { FormAndOverviewWrapper } from '@/features/dialogs/common/components/FormAndOverviewWrapper'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { DialogForm } from '@/features/dialogs/common/components/form/DialogForm'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { FormFieldsForDialog, PageStatus } from '@/features/dialogs/common/types'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { UseFormReturn } from 'react-hook-form'
import { PositionOverview } from '../logic/types'
import { LendWithdrawOverviewPanel } from '../components/LendWithdrawOverviewPanel'
import { MyWalletProps } from '@/features/isolated-details/components/my-wallet/MyWallet'

export interface WithdrawViewProps {
  walletOverview: MyWalletProps
  withdrawOptions: TokenWithBalance[]
  withdrawAsset: TokenWithValue
  assetsToWithdrawFields: FormFieldsForDialog
  form: UseFormReturn<AssetInputSchema>
  objectives: Objective[]
  actionsContext: InjectedActionsContext
  pageStatus: PageStatus
  currentPositionOverview: PositionOverview
  updatedPositionOverview?: PositionOverview
}

export function WithdrawView({
  walletOverview,
  withdrawOptions,
  assetsToWithdrawFields,
  form,
  objectives,
  actionsContext,
  pageStatus,
  withdrawAsset,
}: WithdrawViewProps) {
  return (
    <MultiPanelDialog>
      <DialogTitle>{`Withdraw ${withdrawAsset.token.symbol}`}</DialogTitle>

      <FormAndOverviewWrapper>
        <DialogForm
          form={form}
          assetsFields={assetsToWithdrawFields}
          selectorAssets={withdrawOptions}
          balanceType="protocol"
        />
      </FormAndOverviewWrapper>

      <LendWithdrawOverviewPanel withdrawAsset={withdrawAsset} walletOverview={walletOverview} />

      <DialogActionsPanel
        context={actionsContext}
        objectives={objectives}
        onFinish={pageStatus.goToSuccessScreen}
        enabled={pageStatus.actionsEnabled}
      />
    </MultiPanelDialog>
  )
}
